@use "../../../../globals/settings";
@use "../../../../globals/bcp-2022/objects/flyouts";

$self: ".flyout-feature-bar";

:host {
  display: block;
}

.flyout-feature-bar {
  &__inner {
    @include flyouts.feature-bar();
  }

  &--group {
    #{$self}__inner {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &__group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__part-1 {
      flex-grow: 1;
      padding-inline-start: flyouts.$padding-base;
      padding-inline-end: settings.$grid-gutter;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
